import * as types from './mutation_types';

export default {
    [types.CHANGELOG_SET_SEEN_IDS](state, ids) {
        state.seenIds = ids;
        state.loaded = true;
    },
    [types.CHANGELOG_ADD_SEEN_IDS](state, ids) {
        state.seenIds = [...state.seenIds, ...ids];
    },
};
